import { Bar, BarChart, CartesianGrid, Tooltip, XAxis, YAxis } from "recharts";

const STATUS_COLORS = ["#28a745", "#ffc107", "#0d6efd", "#dc3545"];

// Bar chart data
const locationData = [
    { name: "Pune", orders: 85 },
    { name: "Mumbai", orders: 65 },
    { name: "Nagpur", orders: 45 },
    { name: "Kolkata", orders: 35 },
];

const BarChartComponent = () => {
    return (
        <div className="card shadow-sm border-0">
            <div className="card-body">
                <h5 className="card-title">Orders by Location</h5>
                <p className="text-muted mb-4">
                    Distribution of orders across dispatch locations
                </p>
                <BarChart width={350} height={300} data={locationData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Bar
                        dataKey="orders"
                        fill="#0d6efd"
                        radius={[6, 6, 0, 0]}
                    />
                </BarChart>
            </div>
        </div>
    );
};

export default BarChartComponent;
